<template>
  <div v-click-outside="close" class="relative">
    <div id="time_picker" @click="isOpen = !isOpen">
      <!--suppress AllyHtmlVueInspection -->
      <p v-if="!value" class="text-cebeo_gray">{{ placeholder }}*</p>
      <p v-if="value">
        {{ value.value }}
      </p>
      <img src="../../assets/icons/angle-down.svg"/>
    </div>
    <div v-if="isOpen" id="dropdown_content">
      <div v-for="option in options" @click="setOption(option)">
        <p class="option_item"
           :class="{'selected': value && option.id === value.id}">
          {{ option.value }}</p>
      </div>
      <div v-if="options.length === 0">
        <p class="option_item no_slots">
          {{ $t('general.noAvailable') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import vClickOutside from 'click-outside-vue3';

export default {
  name: 'OptionsDropdown',

  props: {
    placeholder: {
      required: false,
      default: ''
    },
    options: {
      required: true,
      type: Array,
      default: []
    },
    value: { required: true }
  },

  data() {
    return {
      isOpen: false,
      selectedOption: null,
    };
  },

  methods: {
    setOption(option) {
      this.selectedOption = option;
      this.$emit('update:value', option);
      this.isOpen = false;
    },

    close() {
      this.isOpen = false;
    }
  },

  directives: {
    clickOutside: vClickOutside.directive
  },
};
</script>
<style scoped>
#time_picker {
  height: 50px;
  line-height: 50px;
  @apply bg-cebeo_blue_faded text-left px-10 uppercase flex justify-between items-center shadow-md cursor-pointer;
}

#dropdown_content {
  max-height: 145px;
  overflow-y: auto;
  @apply absolute w-full bg-white text-left pt-1 border border-t-0 cursor-pointer z-50;
}

#time_picker > p {
  max-width: 90%;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.option_item {
  height: 35px;
  line-height: 35px;
  @apply px-10;
}

.selected {
  @apply bg-cebeo_blue_faded
}

@media only screen and (max-width: 800px) {
  #time_picker > p {
    max-width: 500px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
